<template>
    <section class="all-v">
        <div class="auth-form">
            <h1 :style="theme.header" class="small">Forgot Password</h1>
            <div class="mt-4 text-left">
                <label class="label-mini" for="username">Username/Email address</label>
                <input v-validate="'required'" :class="{ 'is-invalid': errors.has('username') }" class="form-control w-input"
                       v-model.trim="username" id="username" name="username" placeholder="Username/Email address" autofocus/>
                <small class="text-danger " v-if="errors.has('username')">{{ errors.first('username') }}</small>
            </div>
            <div :style="theme.actionRowleft">
                <w-button :inverse="true" id="send-btn" @click="send" :disabled="!username" class="px-4">Send Code</w-button>
            </div>
            <div class="mt-4 text-left">
                <label class="label-mini" for="code">Code</label>
                <input v-validate="'required'" id="code" :class="{ 'is-invalid': errors.has('code') }" class="form-control w-input"
                       v-model="code" name="code" placeholder="Code"/>
                <small class="text-danger " v-if="errors.has('code')">{{ errors.first('code') }}</small>
            </div>
            <div class="mt-4 text-left">
                <label class="label-mini" for="password">Password</label>
                <input v-validate="{ required: true, regex: '[\\S].{4,96}[\\S]' }" id="password" :class="{ 'is-invalid': errors.has('password') }" class="form-control w-input"
                       v-model="password" name="password" type="password" placeholder="Password"/>
                <small class="text-danger " v-if="errors.has('password')">{{ errors.first('password') }}</small>
            </div>
            <div :style="theme.actionRowleft">
                <w-button :inverse="true" id="reset-btn" @click="submit" :disabled="!username || !code" class="px-4">Submit</w-button>
            </div>
            <div class="auth-form-footer">
                <span>
                    <a id="back-signin" :style="theme.link" v-on:click="signIn">Back to Sign In</a>
                </span>
            </div>
            <div class="alert alert-danger mt-4" v-if="error">{{error}}</div>
            <div class="alert alert-success mt-4" v-if="emailSent">Email sent</div>
        </div>
        <w-version/>
    </section>
</template>

<script>
import { Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import AmplifyTheme from '../../style/AmplifyTheme'

const logger = new Logger('ForgotPasswordComp')

export default {
    name: 'ForgotPassword',
    data () {
        return {
            username: '',
            code: '',
            password: '',
            error: '',
            theme: AmplifyTheme,
            emailSent: false
        }
    },
    computed: {
        user () {
            return this.$store.getters['auth/user']
        }
    },
    methods: {
        send () {
            this.emailSent = false
            this.error = false
            Auth.forgotPassword(this.username.toLowerCase()).then(() => {
                this.emailSent = true
                logger.debug('code resent')
            }).catch(err => this.setError(err))
        },
        submit () {
            Auth.forgotPasswordSubmit(this.username.toLowerCase(), this.code, this.password).then(() => {
                return this.$router.push('/').catch(err => err)
            }).catch(err => this.setError(err))
        },
        signIn () {
            this.$router.push('/auth/signIn')
        },
        setError (err) {
            this.error = err ? err.message || err : ''
        }
    },
    mounted () {
        this.$validator.localize('en', {
            custom: {
                password: {
                    regex: 'Please enter at least 6 alphanumeric characters.',
                    required: 'Please enter at least 6 alphanumeric characters.'
                }
            }
        })
    }
}
</script>

<style scoped>
    h1 {
        font-size: 28px !important;
        font-weight: 500 !important;
        color: #1a3f65 !important;
    }

    .auth-form {
        display: inline-block;
        width: 320px;
        margin-top: 85px;
        padding-top: 15px;
    }

    .auth-form-footer {
        display: flex;
        margin-top: 1em;
        justify-content: space-between;
    }

    .auth-form-footer a {
        color: #23B8DC;
    }

    @media (max-width: 576px) {
        .all-v {
            padding-left: 17px;
            padding-right: 17px;
        }

        .auth-form {
            display: block;
            width: 100%;
            max-width: 320px;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
